var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-svg-lvl-3":"cover-back-contour","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 514 430"}},[_c('defs'),_c('g',{attrs:{"id":"Задник_Контур"}},[_c('path',{staticClass:"bc-c-3",attrs:{"d":"M401.37,16H124.66a4.47,4.47,0,0,0-3.18,1.32l-8,8a1.13,1.13,0,0,0-.33.76V414.77H401.37Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }